import { render, staticRenderFns } from "./conversations.vue?vue&type=template&id=601ca232&scoped=true"
import script from "./conversations.ts?vue&type=script&lang=ts&external"
export * from "./conversations.ts?vue&type=script&lang=ts&external"
import style0 from "./conversations.less?vue&type=style&index=0&id=601ca232&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601ca232",
  null
  
)

export default component.exports